/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BookingConfirmationDesignPreviewViewViewModel } from 'app/modules/design/booking-confirmation-design/booking-confirmation-design-detail/models/booking-confirmation-design-preview-view-view.model';
import { BookingConfirmationDesignDetailService } from 'app/modules/design/booking-confirmation-design/booking-confirmation-design-detail/services/booking-confirmation-design-detail.service';
import { BookingConfirmationDesignPreviewViewModel } from '../models/booking-confirmation-design-preview-view.model';

@Component({
	selector: 'booking-confirmation-design-preview-view',
	templateUrl: './booking-confirmation-design-preview-view.component.html',
	styleUrls: ['./booking-confirmation-design-preview-view.component.scss'],
	standalone: false,
})
export class BookingConfirmationDesignPreviewViewComponent implements OnInit, OnChanges {
	@Input() bookingConfirmationDesignId: number;
	@Input() eventId: number;
	viewModel: BookingConfirmationDesignPreviewViewViewModel;

	@Input() backgroundColour = '#FFFFFF';
	@Input() textColour = '#000000';
	@Input() borderColour = '#000000';
	@Input() headingBackgroundColour = '#FFFFFF';
	@Input() headingTextColour = '#000000';
	@Input() subheadingBackgroundColour = '#F0F0F0';
	@Input() subheadingTextColour = '#000000';
	@Input() linksColour = '#0000EE';

	@Input() emailBody = '';
	get displayEmailBody(): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(this.emailBody ?? '');
	}

	@Input() imageUrl = '';
	get displayImage(): string {
		const image = this.imageUrl;
		if (image && !image.startsWith('http') && !image.startsWith('data:image')) {
			// Assume it's a base64 JPEG string
			return `data:image/png;base64,${image}`;
		}
		return image;
	}

	@Input() socialMediaLinks = [];
	get hasSocials(): boolean {
		return Array.isArray(this.socialMediaLinks) && this.socialMediaLinks.some((link) => link.included);
	}

	get socials() {
		if (!this.hasSocials) {
			return {
				socialLinks: [],
			};
		}

		return Array.isArray(this.socialMediaLinks) ? this.socialMediaLinks.filter((link) => link.included) : [];
	}

	event: any;
	customer: any;
	orderNumber: string;
	tickets: any;
	dispatch: any;
	paymentPlan: any;
	fees: any;
	rules: any;
	footer: any;

	brandName = 'Sample Brand';

	hasAnySocialOrFooter: boolean = true;
	isDispatchPost = true;

	constructor(
		private route: ActivatedRoute,
		private service: BookingConfirmationDesignDetailService,
		private sanitizer: DomSanitizer,
	) {
		this.bookingConfirmationDesignId = route.snapshot.params['id'];
	}

	ngOnInit() {
		this.loadViewModel();
	}

	ngOnChanges(changes: SimpleChanges) {}

	loadViewModel() {
		// if (this.bookingConfirmationDesignId) {
		this.service.getBookingConfirmationDesignPreviewView(this.bookingConfirmationDesignId, this.eventId).then((response: BookingConfirmationDesignPreviewViewModel) => {
			this.viewModel = new BookingConfirmationDesignPreviewViewViewModel(response);
			this.viewModel.itemId = response.id;
			this.event = this.viewModel.dataModel.event;
			this.customer = this.viewModel.dataModel.customer;
			this.orderNumber = this.viewModel.dataModel.orderNumber;
			this.tickets = this.viewModel.dataModel.tickets;
			this.dispatch = this.viewModel.dataModel.dispatch;
			this.paymentPlan = this.viewModel.dataModel.paymentPlan;
			this.fees = this.viewModel.dataModel.fees;
			this.rules = this.viewModel.dataModel.rules;
			this.footer = this.viewModel.dataModel.footer;
		});
		// }
	}

	get backgroundColorStyle() {
		return this.backgroundColour;
	}

	public reload() {
		this.loadViewModel();
	}

	doIconButtonAction(action) {
		switch (action) {
			default: {
				console.log('Unsupported action: ' + action);
				break;
			}
		}
	}
}
